import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function GenerateLeadsInsights() {
    return (
        <OnboardingBody
            statusText='New: Shared email inbox'
            title='Generate leads, create contacts and get insights automatically'
        >
            <p>
                Nutshell AI automatically generates contact records and leads, along with all the
                necessary tasks, activities, and stage-related automations.
            </p>
        </OnboardingBody>
    );
}
